<template>
    <div class="record">
        <div v-if="selectedLayoutId === 0 || !metaData.isFeatureFlag33491Enabled" class="slides">
            <div>
                <ds-text-button
                    :class="{'tab-selected': setTabSelected('ContactInfo')}"
                    data-qa="contact-info"
                    class="button"
                    @click="sendTabEvent('ContactInfo')"
                >
                    Contact info
                </ds-text-button>
            </div>

            <div v-if="!metaData.isFeatureFlag33491Enabled" class="custom-tabs">
                <div
                    v-for="(customField, index) in customFieldList"
                    :key="index"
                    ref="custmtab"
                    :class="{'tab-selected': setTabSelected('customFlds_'+customField.name+'tbNme_tbsId'+customField.id)}"
                    :data-qa="`customFlds_${customField.id}`"
                    class="button custom-button"
                    @click="sendTabEvent('customFlds_'+customField.name+'tbNme_tbsId'+customField.id)"
                >
                    {{ customField.name }}
                </div>
            </div>

            <div v-if="selectedLayoutId === 0 && metaData.isFeatureFlag33491Enabled">
                <ds-text-button
                    :class="{'tab-selected': setTabSelected('CustomFields')}"
                    data-qa="contact-custom-field"
                    class="button"
                    @click="sendTabEvent('CustomFields')"
                >
                    Custom Fields
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    :class="{'tab-selected': setTabSelected('ContactNotes')}"
                    data-qa="contact-notes"
                    class="button"
                    @click="sendTabEvent('ContactNotes')"
                >
                    Notes
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    :class="{'tab-selected': setTabSelected('ContactTags')}"
                    data-qa="contact-tags"
                    class="button"
                    @click="sendTabEvent('ContactTags')"
                >
                    Tags
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    :class="{'tab-selected': setTabSelected('ContactMoney')}"
                    data-qa="contact-money"
                    class="button"
                    @click="sendTabEvent('ContactMoney')"
                >
                    Money
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactTasks')}"
                    data-qa="contact-tasks"
                    @click="sendTabEvent('ContactTasks')"
                >
                    Tasks
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactAppointments')}"
                    data-qa="contact-appointments"
                    @click="sendTabEvent('ContactAppointments')"
                >
                    Appointments
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactForms')}"
                    data-qa="contact-form-submissions"
                    @click="sendTabEvent('ContactForms')"
                >
                    Form submissions
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactEmails')}"
                    data-qa="contact-emails"
                    @click="sendTabEvent('ContactEmails')"
                >
                    Emails
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactCampaigns')}"
                    data-qa="contact-campaigns"
                    @click="sendTabEvent('ContactCampaigns')"
                >
                    Campaigns
                </ds-text-button>
            </div>

            <div v-if="displayCampaignStealthTab">
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactCampaignsStealth')}"
                    data-qa="contact-campaigns-stealth"
                    @click="sendTabEvent('ContactCampaignsStealth')"
                >
                    Campaigns stealth
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactOpportunities')}"
                    data-qa="contact-opportunities"
                    @click="sendTabEvent('ContactOpportunities')"
                >
                    Opportunities
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ScoredActivities')}"
                    data-qa="contact-scored-activities"
                    @click="sendTabEvent('ScoredActivities')"
                >
                    Scored activity
                </ds-text-button>
            </div>
            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactFiles')}"
                    data-qa="contact-files"
                    @click="sendTabEvent('ContactFiles')"
                >
                    Files
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('LinkedContacts')}"
                    data-qa="contact-linked-contacts"
                    @click="sendTabEvent('LinkedContacts')"
                >
                    Linked contacts
                </ds-text-button>
            </div>

            <div v-if="!metaData.isRemoveLowUsageTabsEnabled">
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactFollowUpSequences')}"
                    data-qa="contact-followup-sequences"
                    @click="sendTabEvent('ContactFollowUpSequences')"
                >
                    Follow-up sequences
                </ds-text-button>
            </div>

            <div v-if="!metaData.isRemoveLowUsageWebProfileTabEnabled">
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactWebProfile')}"
                    data-qa="contact-web-profile"
                    @click="sendTabEvent('ContactWebProfile')"
                >
                    Web profile
                </ds-text-button>
            </div>

            <div v-if="!metaData.isRemoveLowUsageTabsEnabled">
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactAccessPrivileges')}"
                    data-qa="contact-access-privileges"
                    @click="sendTabEvent('ContactAccessPrivileges')"
                >
                    Access privileges
                </ds-text-button>
            </div>

            <div>
                <ds-text-button
                    class="button"
                    :class="{'tab-selected': setTabSelected('ContactReferralPartner')}"
                    data-qa="contact-referral-partner"
                    @click="sendTabEvent('ContactReferralPartner')"
                >
                    Referral partner
                </ds-text-button>
            </div>
        </div>
        <div v-if="selectedLayoutId > 0 && metaData.isFeatureFlag33491Enabled" class="slides-display custom-layout-contact-record">
            <custom-layout-contact-record :id="id" :contact-layout-details="contactLayoutDetails" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import CustomLayoutContactRecord from './layout/CustomLayoutContactRecord';

export default {
    name: 'ContactHeader',

    components: {
        CustomLayoutContactRecord,
    },

    props: {
        id: [String, Number],
        metaData: Object,
    },

    data() {
        return {
            customFieldList: [],
            selectedTab: 'ContactInfo',
            selectedLayoutId: 0,
            contactLayoutDetails: {},
            displayCampaignStealthTab: false,
        };
    },

    mounted() {
        this.$root.$on('LAYOUTID_TAB', (data) => {
            this.contactLayoutDetails = data;
            this.selectedLayoutId = Number(data.id);
        });
    },

    created() {
        this.getCustomeTabName();
        this.selectedLayoutId = Number(this.metaData.defaultLayoutId);
        this.displayCampaignStealthTab = this.metaData?.isContactTabCampaignStealthEnable;
    },

    methods: {
        sendTabEvent(tabName) {
            this.$root.$emit('TAB_SELECTED', tabName);
            this.selectedTab = tabName;
        },

        setTabSelected(tabName) {
            return this.selectedTab === tabName;
        },

        async getCustomeTabName() {
            try {
                const response = await axios.get('/app/customFields/getAllCustomTabs');

                this.customFieldList = response.data;
            } catch (error) {
                this.$error({ message: 'error occurred while loading custom tabs ' });
            }
        },

    },
};
</script>

<style lang="scss" scoped>
.button {
    margin: $spacing-075 0;
    padding: 0 $spacing-200;
    height: 28px;
    display: inline-flex;
    align-items: center;
    font-size: small;
    color: $color-text;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: $color-gray-20;
    border: none;
    border-radius: 28px;
    cursor: pointer;

    &:hover,
    &:active {
        color: $color-text;
        background-color: $color-white;
        box-shadow: $drop-shadow-z2;
    }

    &:focus {
        outline: 0;
    }
}

.record {
    display: flex;
}

.slides {
    display: flex;
    flex-flow: row wrap;
    @include padding-start(4px);

    > div {
        @include margin-end($spacing-100);
    }
}

.slides-display {
    display: flex;
    flex-flow: row wrap;
    @include padding-start(4px);

    > div {
        @include margin-end($spacing-100);
    }
}

.custom-layout-contact-record {
    width: 100%;
}

.tab-selected {
    background-color: $color-white;
    box-shadow: $drop-shadow-z2;
}

@media screen and ($small) {
    .record {
        margin: 0 -24px;
    }

    .slides {
        flex-flow: row nowrap;
        overflow-x: auto;
        padding: 0 $spacing-300;
    }

    .slides::-webkit-scrollbar {
        display: none;
    }

    .slides-display {
        flex-flow: row nowrap;
        overflow-x: auto;
        padding: 0 $spacing-300;
    }

    .slides-display::-webkit-scrollbar {
        display: none;
    }
}

@media screen and ($medium) {
    .slides {
        display: flex;
        overflow: auto;
    }

    .slides-display {
        display: flex;
    }

    ::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
}

.custom-button {
    margin-right: 0.5rem;
    &:last-child{
        margin-right: 0rem;
    }
}

.custom-tabs {
    display: flex;
}
</style>
